import { useEffect } from 'react'
import globalBus from './Bus'

export function useGlobalBus(
  handlers?: { [E in keyof any]?: (data: any[E]) => any },
  inputs?: any[]
) {
  useEffect(() => {
    if (handlers) {
      globalBus.on(handlers)
      return () => {
        globalBus.off(handlers)
      }
    } else {
      return
    }
  }, inputs)
  return globalBus
}



// WEBPACK FOOTER //
// ./src/services/global-bus.ts